import { combineReducers } from "redux";
import multiQuoteReducers from "./multiQuoteReducer";
import placeNormalTrade from "./placeNormalTrade";
import orderDetails from "./OrderDetails";
import checkMargin from "./CheckMargin";
import brokerCharges from "./BrokerCharges";
import rmsDetails from "./RmsDetails";
import AMOStatus from "./AMOStatus";
import proceedToAuth from "./ProceedToAuth";
import limits from "./LimitsReducer";
import mfParticularHolding from "./MFParticularHolding";
import UserStatus from "./UserStatus";
import upiListReducer from "./UPIListReducer";
import IpoMasterBank from "./IpobankMaster";
import IpoOtpValidate from "./IpoOtpValidate";
import IpoCancel from "./IpoCancel";
export default combineReducers({
    multiQuoteReducers,
    placeNormalTrade,
    orderDetails,
    checkMargin,
    brokerCharges,
    rmsDetails,
    AMOStatus,
    proceedToAuth,
    limits,
    mfParticularHolding,
    UserStatus,
    upiListReducer,
    IpoMasterBank,
    IpoOtpValidate,
    IpoCancel,
});
